import * as React from 'react';
import { useContext } from 'react';
import { CartContext } from '../Cart';
import CartServiceSummary from '../../ServiceSummary';
import { useTranslation } from 'react-i18next';
import { ServiceSummary } from '../../features/service-summary';
import { CheckoutSteps } from '../../MobileStepbar/types';
import { CdnIcon } from '@shared/ui';
const Meals = ({ onServiceDelete, renderService, activeStep, steps }) => {
    var _a;
    const cartConfig = useContext(CartContext);
    const { t } = useTranslation('Cart');
    const group = {
        header: t('Meal'),
        icon: React.createElement(CdnIcon, { icon: 'Services/Meal' }),
        totalPrice: (_a = cartConfig.totalPrices) === null || _a === void 0 ? void 0 : _a.meal,
        disabled: activeStep < (steps === null || steps === void 0 ? void 0 : steps.findIndex(step => step.type === CheckoutSteps.Meal)) || false
    };
    return (React.createElement(ServiceSummary, { serviceType: "Meal", onDelete: onServiceDelete }, content => {
        var _a;
        return (_a = renderService === null || renderService === void 0 ? void 0 : renderService(CheckoutSteps.Meal, group, content)) !== null && _a !== void 0 ? _a : (React.createElement(CartServiceSummary, { group: group }, content));
    }));
};
export default Meals;
